import PropTypes from 'prop-types';
import React from 'react';
import styles from './Dthc.scss';
import { Button, Icon } from 'semantic-ui-react';
import { DeleteConfirmation } from '../';

export default class DthcActions extends React.Component {

  static propTypes = {
    delete: PropTypes.func,
    save: PropTypes.func,
    reset: PropTypes.func,
    id: PropTypes.string,
    isNew: PropTypes.bool
  }

  render() {
    const deleteButton = (
      <a
        className={styles.actionsMenuSecondaryItem}
        style={{ fontSize: '1.25em' }}
      >
        <Icon name='trash alternate' />
      </a>
    );
    return (
      <div className={styles.actionsMenu}>
        <div className={styles.tableCell}>
          {this.props.delete && !this.props.isNew &&
            <DeleteConfirmation
              delete={this.props.delete}
              trigger={deleteButton}
              key={this.props.id ? this.props.id : (`${Math.random().toString(36)}00000000000000000`).slice(2, 16 + 2)}
            />
          }
        </div>
        <p className={[styles.actionsMenuMiddle, styles.tableCell].join(' ')}>
          {this.props.reset &&
            <a className={styles.actionsMenuSecondaryItem} onClick={this.props.reset}>Cancel</a>
          }
        </p>
        <Button primary type='submit' onClick={this.props.save} className={styles.tableCell}>
          Save
        </Button>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./webpack/components/Modules/Dthc/DthcActions.js